import { FormService } from './FormService';

export class ConvertingNcrService extends FormService {
    constructor() {
        super("ConvertingNcrs");
    }
}